import Vue from 'vue'
import Router from 'vue-router'
import notfound from '@/page/errorPage/404'
import Layout from '../layout/Index';
import application from './application';
import { getSession } from '@/untils';
Vue.use(Router)

let router = new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  // base: '/yzh/', // 绍兴打包需要设置 router base
  routes: [
    {
      path: '/', redirect: { name: "public" }
    },
    {
      path: '/public',
      name: 'public',
      component: Layout,
      children: [
        ...application
      ]
    },
    {
      path: '/404',
      name: '404',
      component: notfound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  // if (getSession('orgId')) {  // 通过 sessionStorage获取当前的 token 是否存在
  //   next();
  // }
  // else {
  //   next({
  //     path: '/public' // 将跳转的路由 path 作为参数，登录成功后跳转到该路由
  //   })
  // }
  let isLogin = getSession('orgId');
  if (isLogin) {
    //如果用户信息存在则往下执行。
    next()
  } else {
    //如果用户token不存在则跳转到login页面
    if (to.path === '/public') {
      next()
    } else {
      next('/public')
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js